import React from '/web_modules/./react.js';
import logo from '/assets/imgs/logo-colorful-pixelated.png';
import face from '/assets/imgs/face.png';
import './App.css';

function App() {
  return /*#__PURE__*/React.createElement("div", {
    className: 'App'
  }, /*#__PURE__*/React.createElement("header", {
    className: "App-header"
  }, /*#__PURE__*/React.createElement("img", {
    src: face,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement("p", null, "What are you doing here?"), /*#__PURE__*/React.createElement("a", {
    className: "App-link",
    href: "https://lucho.dev/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Visit my real website"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("cite", null, "Note: This is a placeholder page, to test", ' ', /*#__PURE__*/React.createElement("a", {
    className: "App-link",
    href: "https://www.snowpack.dev/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Snowpack"))))));
}

export default App;
